module.exports = __webpack_public_path__ + "media/images/awards/app-store-e587dc00d15bc97d5637b9dd8b22a0c9.png";